<template>
  <div>
    <div class="title">发票开具周期？</div>
    <div class="content-info">
      <p class="txt1">
        自发票申请提交之日起，预计需要4至7个工作日；
        <br />若订单中包含第三方卖家商品，该商品发票由卖家提供，预计将在发票需求日期后的12个工作日内送达。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
